import { Injectable } from '@angular/core';

// https://denys.dev/2018-03-18/simple-i18n-support-for-your-angular-apps/

@Injectable({
  providedIn: 'root'
})
export class DownloadService {

  download(downloadResponse: any) {

    let ab: any
    if(downloadResponse.buffer64) {

      var byteString = atob(downloadResponse.buffer64);
      ab = new ArrayBuffer(byteString.length);
      var ia = new Uint8Array(ab);

      for (var i = 0; i < byteString.length; i++) {
          ia[i] = byteString.charCodeAt(i);
      }
    } else {
      ab = downloadResponse.buffer
    }
    const blob = new Blob([ ab ], { type: downloadResponse.content_type || 'application/pdf'  })
    // const blob = new File([ ab ], "hello.pdf", {"type": "application/pdf"})

    // IE doesn't allow using a blob object directly as link href
    // instead it is necessary to use msSaveOrOpenBlob
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(blob);
      return;
    }
    const isSafari = /^((?!chrome|android).)*safari/i.test(window.navigator && window.navigator.userAgent || '');

    const objectUrl = window.URL.createObjectURL(blob)

    const link = document.createElement('a')
    // link.href = `data:application/pdf;base64,` + downloadResponse.buffer64
    link.href = objectUrl
    if(!isSafari && !downloadResponse.force_download) {
      link.target = '_blank'
    } else {
      link.download = downloadResponse.file_name
    }
    document.body.appendChild(link)

    link.click()
    // link.dispatchEvent(new MouseEvent('click', {ctrlKey: true, button: 0}));
    // window.open(objectUrl, '_blank')
    setTimeout(() => {
      document.body.removeChild(link)
      // window.URL.revokeObjectURL(objectUrl)
    }, 100)
  }

}
